import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentChamadoEnviado from './ContentChamadoEnviado';

const CalledSent = () => {
  return (
    <>
      <Header />
      <ContentChamadoEnviado />
      <Bottom />
    </>
  );
};

export default CalledSent;
